import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import {
  OutboxGesecInvoicePutRequest,
  useBusinessCentralOutboxGesecInvoicePutMutation,
} from "@/services/backend/business-central/api/outbox-gesec-invoice-api";
import { OutboxStatus } from "../types/outbox";

export function OutboxGesecInvoiceCreateDialog({
  onSuccess,
}: {
  onSuccess?: (outboxId: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<Partial<OutboxGesecInvoicePutRequest>>(
    {
      outboxId: v4(),
      outboxStatus: OutboxStatus.InProgress,
      outboxCreatedAt: new Date().toISOString(),
      outboxUpdatedAt: new Date().toISOString(),
      id: v4(),
    },
  );
  const [put, { isLoading, error, isSuccess, reset }] =
    useBusinessCentralOutboxGesecInvoicePutMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
      onSuccess?.(request.outboxId!);
      setRequest({
        outboxId: v4(),
        outboxStatus: OutboxStatus.InProgress,
        outboxCreatedAt: new Date().toISOString(),
        outboxUpdatedAt: new Date().toISOString(),
        id: v4(),
      });
    }
  }, [isSuccess, onSuccess, request.outboxId, reset]);

  const doCreate = () => {
    if (isLoading) return;
    put(request as OutboxGesecInvoicePutRequest);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm">
          <Plus />
          <span>{t("Übermittlung")}</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Neue Rechungsübermittlung erstellen")}</DialogTitle>
          <DialogDescription>
            {t("Erstellen Sie eine neue Übermittlung an Business Central.")}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doCreate} />
      </DialogContent>
    </Dialog>
  );
}
